const colors = [{
  id: 'butter',
  name: 'Butter',
  value: '#f7efd0'
}, {
  id: 'peach',
  name: 'Peach',
  value: '#f6e3d8'
}, {
  id: 'rose',
  name: 'Rose',
  value: '#f3dfe6'
}, {
  id: 'lavender',
  name: 'Lavender',
  value: '#ebe5f5'
}, {
  id: 'sky',
  name: 'Sky',
  value: '#e0eef2'
}, {
  id: 'sage',
  name: 'Sage',
  value: '#e5eddd'
}];

const minimumSize = {
  width: 240,
  height: 100
};

const maximumSize = {
  width: 1200,
  height: 1200
};

const clamp = function(value, min, max) {
  return Math.max(min, Math.min(max, value));
};

const moveNote = function(note, dx, dy, bottom = Infinity, headerHeight = 28) {
  return {
    x: note.x + dx,
    y: Math.min(note.y + dy, bottom - headerHeight)
  };
};

const resizeNote = function(note, dx, dy, snap = false) {
  const snapSize = value => snap ? Math.round(value / 20) * 20 : value;
  if (note.kind === 'image') {
    const ratio = note.aspectRatio || note.width / note.height;

    // Project the pointer onto the image diagonal instead of switching axes.
    const delta = (dx * ratio * ratio + dy * ratio) / (ratio * ratio + 1);
    const minimumWidth = Math.min(80, 80 * ratio, note.width);
    // Snap the longer dimension while keeping the image proportions intact.
    const nextWidth = ratio >= 1 ? snapSize(note.width + delta) : snapSize((note.width + delta) / ratio) * ratio;
    const width = Math.max(minimumWidth, nextWidth);

    return {
      width,
      height: width / ratio
    };
  }

  return {
    width: clamp(snapSize(note.width + dx), minimumSize.width, maximumSize.width),
    height: clamp(snapSize(note.height + dy), minimumSize.height, maximumSize.height)
  };
};

const createNote = function({
  kind = 'note',
  color = 'butter',
  x = 32,
  y = 32,
  width = 300,
  title = '',
  text = '',
  images = []
} = {}) {
  return {
    id: crypto.randomUUID(),
    kind,
    color,
    x,
    y,
    width: clamp(width, minimumSize.width, maximumSize.width),
    height: images.length ? 380 : 300,
    title,
    text,
    images
  };
};

// Keep expanded dimensions in storage while measuring minimized items on the board.
const noteWidth = note => note.kind === 'image' && note.minimized ? 60 : note.width;
const noteHeight = note => note.minimized ? (note.kind === 'image' ? 60 : 28) : note.height;

const boardSize = function(notes) {
  return {
    width: Math.max(0, ...notes.map(note => note.x + noteWidth(note) + 48)),
    height: Math.max(0, ...notes.map(note => note.y + noteHeight(note) + 48))
  };
};

const fitImage = function(width, height, viewportWidth, viewportHeight, zoom = 1) {
  const scale = Math.min(1, viewportWidth * 0.9 / zoom / width, viewportHeight * 0.9 / zoom / height);

  return {
    width: width * scale,
    height: height * scale,
    aspectRatio: width / height
  };
};

export {
  colors,
  minimumSize,
  maximumSize,
  moveNote,
  resizeNote,
  createNote,
  boardSize,
  noteHeight,
  noteWidth,
  fitImage
};
